<template>
    <div>
        <q-select v-model="selectedValue"
                v-bind="$attrs"
                :options="options"
                use-input fill-input hide-selected
                emit-value map-options
                @filter="filterFn">
            <template v-if="isNotEmpty(selectedValue)" v-slot:append>
                <q-icon name="cancel" @click.stop.prevent="clearValue" class="cursor-pointer" />
            </template>
        </q-select>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { $http } from "@/boot/http";
import _ from "lodash";

export default defineComponent({
    name: "SelectSubDistrict",
    emits: ['update:modelValue', 'selected-option', 'clear-value', 'change'],
    props: {
        districtCode: { type: String, default: ''},
        address: { type: Object, default: {} as any },
        mapValue: { type: String, default: ''},
        isShowAll: { type: Boolean, default: false }
    },
    setup(props, { emit, attrs }) {
        const options = ref([] as any[]);
        const cloneOptions = ref([] as any[]);
        const selectedValue = ref(null as string | null)
        const fetchMapData = () => {
            setTimeout(() => {
                if (!_.isEmpty(props.mapValue)) {
                    let mapValue = props.mapValue.toLocaleLowerCase()
                    let found = cloneOptions.value.find(v => (v.label.toLowerCase()).indexOf(mapValue) > -1);
                    if (!_.isEmpty(found?.value)) {
                        selectedValue.value = String(found.value)
                    }
                }
            },1000);
        };
        const fetchData = async () => {
            let params = {} as any;
            options.value = [] as any[];
            if (!_.isEmpty(props.districtCode) && props.districtCode != 'ALL') {
                params.districtCode = props.districtCode
                let resp = await $http.get(`/api/dropdown/findSubDistrict`, { params: { ...params } });
                options.value = [];
                if (props.isShowAll) {
                    options.value.push({ value: "ALL", label: "ALL" });
                }
                _.each(resp.data, v => {
                    options.value.push({
                        value: String(v.dropdownCode),
                        label: String(v.dropdownName),
                        zipCode: String(v.value1)
                    });
                });
                cloneOptions.value = options.value
            } else {
                selectedValue.value = null
            }
        };
        //eslint-disable-next-line @typescript-eslint/no-unused-vars
        watch(() => attrs.modelValue, (newVal, oldVal) => {
            selectedValue.value = null
            if (newVal) selectedValue.value = attrs.modelValue as any
        }, { immediate: true });
        watch(() => props.districtCode, fetchData, { immediate: true });
        watch(() => props.mapValue, fetchMapData, { immediate: true });
        watch(() => selectedValue.value, () => {
            if (!_.isEmpty(selectedValue.value)) {
                emit('update:modelValue', String(selectedValue.value));
                emit('change', props.address);
                emit('selected-option', cloneOptions.value.find((f:any) => f.value == selectedValue.value), props.address);
            } else {
                emit('update:modelValue', null);
            }
        });
        return {
            selectedValue,
            options,
            isNotEmpty: (data:any) => {
                return !_.isEmpty(data)
            },
            clearValue: () => {
                selectedValue.value = null
                if (props.address) {
                    emit('clear-value', props.address);
                }
            },
            filterFn (val:string, update:any) {
                update(() => {
                    if (val === '') {
                        options.value = cloneOptions.value
                    } else {
                        const needle = val.toLowerCase()
                        options.value = cloneOptions.value.filter(v => (v.label.toLowerCase()).indexOf(needle) > -1);
                    }
                })
            }
        };
    }
});
</script>